// Shared ergonomics + styling kit for the 5 申請フォーム modals.
// Keeps every form visually consistent and respects the critical constraints:
// inline modal (no portal), solid z-[60] scrim (no backdrop-filter), dropdowns z-[70].

// Local-timezone YYYY-MM-DD (safe default for <input type="date">).
export const todayISO = () => new Date().toLocaleDateString('sv-SE');

// 必須 (required) / 任意 (optional) badges — clearer than a bare red asterisk.
export const Req = () => (
  <span className="ml-2 inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold leading-none tracking-wider text-white bg-red-600 align-middle">
    必須
  </span>
);

export const Opt = () => (
  <span className="ml-2 inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold leading-none tracking-wider text-zinc-500 bg-zinc-100 align-middle">
    任意
  </span>
);

// Consistent label row.
export const labelCls = 'text-sm font-semibold text-zinc-800 flex items-center';

// Comfortable, mobile-friendly field styles (h-11 ≈ 44px touch target).
export const fieldInput =
  'h-11 border-zinc-300 bg-white rounded-lg focus:ring-2 focus:ring-teal-700/20 focus:border-teal-700 hover:border-zinc-400 transition-colors';
export const fieldTextarea =
  'border-zinc-300 bg-white rounded-lg min-h-[110px] focus:ring-2 focus:ring-teal-700/20 focus:border-teal-700 hover:border-zinc-400 transition-colors';
export const fieldTrigger =
  'h-11 border-zinc-300 bg-white rounded-lg focus:ring-2 focus:ring-teal-700/20 focus:border-teal-700 hover:border-zinc-400 transition-colors';

// Footer action buttons — cohesive primary CTA.
export const btnPrimary =
  'h-11 px-6 rounded-lg bg-teal-700 hover:bg-teal-800 text-white font-medium shadow-sm hover:shadow-md active:scale-[0.98] transition-all';
export const btnSecondary =
  'h-11 px-6 rounded-lg border-zinc-300 text-zinc-700 hover:bg-zinc-50 hover:text-zinc-900 active:scale-[0.98] transition-all';
